import { OrderTypes } from "@shared/types";
import { createTradeOrdersAnnotations } from "@shared/features/tradingTerminal/common/utils";
import { TradingTerminalContext } from "@shared/features/tradingTerminal/TradingTerminal.context";
import { useContext, useMemo } from "react";
import { useTheme } from "styled-components";

const useTradingTerminalChart = () => {
  const appTheme = useTheme();
  const {
    symbols,
    account,
    precisionConfig,
    useTakeProfitOrders,
    useStopOrders,
    existingQuantityOrder,
    entryOrders,
    takeProfitOrders,
    stopOrders,
    getCreateGeneralDataQuery,
    useFreeTextData,
    useTradingTerminalOldVersion,
    freeTextProcessed,
    amountCoin,
    currentPrice,
    amount,
    exchanges,
  } = useContext(TradingTerminalContext)!;

  const allEntryOrders = useMemo(
    () =>
      existingQuantityOrder
        ? [existingQuantityOrder, ...entryOrders]
        : entryOrders,
    [existingQuantityOrder, entryOrders]
  );

  const annotationOrders = useMemo(() => {
    return {
      [OrderTypes.ENTRY]: allEntryOrders,
      [OrderTypes.TAKE_PROFIT]: useTakeProfitOrders ? takeProfitOrders : [],
      [OrderTypes.STOP]: useStopOrders ? stopOrders : [],
    };
  }, [
    allEntryOrders,
    takeProfitOrders,
    stopOrders,
    useTakeProfitOrders,
    useStopOrders,
  ]);

  const annotations = useMemo(
    () =>
      createTradeOrdersAnnotations(annotationOrders, precisionConfig, appTheme),
    [annotationOrders, precisionConfig, appTheme]
  );

  const showEmptyState = getCreateGeneralDataQuery.error && useFreeTextData;

  return {
    symbols,
    account,
    annotations,
    showEmptyState,
    useTradingTerminalOldVersion,
    freeTextProcessed,
    appTheme,
    amountCoin,
    precisionConfig,
    currentPrice,
    amount,
    exchanges,
  };
};

export default useTradingTerminalChart;
